import Glide from "@glidejs/glide";

function detectMobile() {
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}

function initGlideDefault(glideDefaultElement, isMobile) {
  let glideInstance = new Glide(glideDefaultElement, {
    type: "carousel",
    perView: 1,
    animationDuration: 100,
    swipeThreshold: 40,
    dragThreshold: isMobile ? true : false,
    keyboard: false,
    breakpoints: { 768: { dragThreshold: true } },
    width: "100%",
  });
  glideInstance.mount();
  return glideInstance;
}

function initGlideListing(glideListingElement, isMobile) {
  let glideListingInstance = new Glide(glideListingElement, {
    type: "carousel",
    perView: 1,
    animationDuration: 100,
    swipeThreshold: 40,
    dragThreshold: isMobile ? true : false,
    keyboard: false,
    breakpoints: { 768: { dragThreshold: true } },
    width: "100%",
  });
  glideListingInstance.mount();
  return glideListingInstance;
}

function setupGlideDefaultInstance(glideDefault, isMobile) {
  let glideInstance = initGlideDefault(glideDefault, isMobile);

  if (!isMobile) {
    glideInstance.on("mount.after", function () {
      glideDefault.classList.remove("glide--swipeable");
    });
  }

  glideInstance.on("touch.start", addClassToBody(isMobile));
  glideInstance.on("drag.start", addClassToBody(isMobile));
  handleArrowsOnLoad(glideInstance.selector);
  return glideInstance;
}

function setupGlideListingInstance(glideListing, isMobile) {
  let glideListingInstance = initGlideListing(glideListing, isMobile);

  if (!isMobile) {
    glideListingInstance.on("mount.after", function () {
      glideListing.classList.remove("glide--swipeable");
    });
  }

  glideListingInstance.on("touch.start", addClassToBody(isMobile));
  glideListingInstance.on("drag.start", addClassToBody(isMobile));

  handleThumbnails(glideListingInstance);
  handleSlides(glideListingInstance, glideListing);
  handleArrowsOnLoad();
  return glideListingInstance;
}

function addClassToBody(isMobile) {
  return () => {
    if (isMobile) {
      document.body.classList.add("lightbox-open");
    }
  };
}

function handleThumbnails(glideListingInstance) {
  const thumbnails = document.querySelectorAll(".carousel__thumbnails li");

  if (thumbnails.length > 0) {
    removeActiveClassFromThumbnails(thumbnails);

    thumbnails.forEach((thumbnail, index) => {
      bindThumbnailClick(thumbnail, index, glideListingInstance, thumbnails);
    });

    glideListingInstance.on("move.after", () => {
      const activeSlideIndex = glideListingInstance.index;
      removeActiveClassFromThumbnails(thumbnails);
      if (thumbnails[activeSlideIndex]) {
        thumbnails[activeSlideIndex].classList.add("active");
      }
    });
  }
}

function removeActiveClassFromThumbnails(thumbnails) {
  thumbnails.forEach((thumbnail) => {
    if (thumbnail) {
      thumbnail.classList.remove("active");
    }
  });
}

function bindThumbnailClick(
  thumbnail,
  index,
  glideListingInstance,
  thumbnails
) {
  if (thumbnail) {
    thumbnail.addEventListener("click", () => {
      removeActiveClassFromThumbnails(thumbnails);
      thumbnail.classList.add("active");
      glideListingInstance.go("=" + index);
    });

    if (index === 0) {
      thumbnail.classList.add("active");
    }
  }
}

function handleSlides(glideFullscreenInstance, glideListing, isMobile) {
  const slides = glideListing.querySelectorAll(".glide__slide");
  const galleryFullscreen = document.querySelector(".gallery__fullscreen");

  slides.forEach((slide, index) => {
    if (slide) {
      slide.addEventListener("click", () => {
        galleryFullscreen.classList.add("open");

        const glideFullscreen = glideListing.querySelector(
          ".gallery__fullscreen"
        );
        const correctIndex = index - 2; // don't ask me why

        glideFullscreenInstance = new Glide(glideFullscreen, {
          type: "carousel",
          perView: 1,
          animationDuration: 100,
          swipeThreshold: 40,
          dragThreshold: false,
          keyboard: true,
          breakpoints: {
            768: {
              dragThreshold: true,
              keyboard: false,
            },
          },
          width: "100%",
          startAt: correctIndex,
        });
        glideFullscreenInstance.mount();
      });
    }
  });

  document.addEventListener("DOMContentLoaded", (event) => {
    let closeButton = document.querySelector(
      '[data-glide-el="controls[closeFullscreen]"]'
    );
    let galleryFullscreen = document.querySelector(".gallery__fullscreen");

    closeButton?.addEventListener("click", (event) => {
      event.preventDefault();
      galleryFullscreen?.classList.remove("open");
      glideFullscreenInstance.destroy();
    });

    document.addEventListener("keydown", (event) => {
      if (
        event.keyCode === 27 &&
        galleryFullscreen?.classList.contains("open")
      ) {
        galleryFullscreen?.classList.remove("open");
        glideFullscreenInstance.destroy();
      }
    });
  });
}

function handleArrowsOnLoad(glideInstance = document) {
  document.addEventListener("DOMContentLoaded", function () {
    const leftArrow = glideInstance.querySelector(".carousel__arrow--left");
    const rightArrow = glideInstance.querySelector(".carousel__arrow--right");
    const carouselContainer = glideInstance.querySelector(".no-scrollbar");

    if (leftArrow && rightArrow && carouselContainer) {
      // Set the percentage of clientWidth to scroll
      const scrollPercentage = 0.8; // Adjust as needed

      // Function to update arrow opacity
      function updateArrowOpacity() {
        if (carouselContainer.scrollLeft === 0) {
          leftArrow.style.opacity = 0;
          rightArrow.parentElement.parentElement.parentElement.classList.add(
            "reached-left-end"
          );
        } else {
          leftArrow.style.opacity = 1;
          rightArrow.parentElement.parentElement.parentElement.classList.remove(
            "reached-left-end"
          );
        }

        if (
          carouselContainer.scrollLeft + carouselContainer.clientWidth >=
          carouselContainer.scrollWidth
        ) {
          rightArrow.style.opacity = 0;
          rightArrow.parentElement.parentElement.parentElement.classList.add(
            "reached-right-end"
          );
        } else {
          rightArrow.style.opacity = 1;
          rightArrow.parentElement.parentElement.parentElement.classList.remove(
            "reached-right-end"
          );
        }
      }

      // Initial opacity check
      updateArrowOpacity();

      // Scroll event listener
      carouselContainer.addEventListener("scroll", updateArrowOpacity);

      bindArrowClick(leftArrow, carouselContainer, scrollPercentage, false);
      bindArrowClick(rightArrow, carouselContainer, scrollPercentage, true);
    }
  });
}

function bindArrowClick(arrow, carouselContainer, scrollPercentage, isRight) {
  arrow.addEventListener("click", function () {
    // Scroll the carousel
    const scrollDistance = carouselContainer.clientWidth * scrollPercentage;
    carouselContainer.scrollTo({
      left: carouselContainer.scrollLeft + (isRight ? 1 : -1) * scrollDistance,
      behavior: "smooth",
    });
  });
}

function setupMobileSwipe(carouselContainer) {
  let activeElement = null;
  const carouselItems = document.querySelectorAll(".carousel-item");

  const setActiveElement = () => {
    let nearestElementToTheCenter;
    let nearestXPositionToTheCenter;
    let containerCenter = carouselContainer.clientWidth / 2;

    carouselItems.forEach((glideDefault) => {
      const positionInfo = glideDefault.getBoundingClientRect();
      const elementWidth = positionInfo.width;
      const xPosition = positionInfo.x + elementWidth/2;

      if (typeof nearestXPositionToTheCenter !== "number" || Math.abs(containerCenter - xPosition) < Math.abs(nearestXPositionToTheCenter)) {
        nearestElementToTheCenter = glideDefault;
        nearestXPositionToTheCenter = containerCenter - xPosition;
      }
    });

    activeElement = nearestElementToTheCenter;

    const positionInfo = nearestElementToTheCenter.getBoundingClientRect();
    const leftPosition = positionInfo.x;
    const elementWidth = positionInfo.width + 12; // paddings = 12

    carouselContainer.scrollBy({
      left: -((document.body.clientWidth - elementWidth) / 2 - leftPosition),
      behavior: "smooth",
    });

    activeElement.classList.add("active");
  }

  let scrolling = false;
  carouselContainer.addEventListener("touchstart", () => scrolling = false);
  carouselContainer.addEventListener("touchend", () => {
    scrolling = true;
    activeElement?.classList.remove("active");
    let currentScroll = carouselContainer.scrollLeft;

    const isScrolling = () => {
      if (carouselContainer.scrollLeft !== currentScroll && scrolling) {
        // scrolling
        currentScroll = carouselContainer.scrollLeft;
        window.requestAnimationFrame(isScrolling);
      } else if (scrolling) {
        // scrolling stopped
        setActiveElement();
        scrolling = false;
      }
    }
    window.requestAnimationFrame(isScrolling);
  });

  const firstCarouselItem = carouselItems[0]
  if (firstCarouselItem) {
    activeElement = firstCarouselItem;
    activeElement.classList.add("active");
  }
}

export function setupGlide() {
  const isMobile = detectMobile();

  const glideDefaults = document.querySelectorAll(".glide-default");
  const glideListings = document.querySelectorAll(".glide-listing");
  const glideFullscreens = document.querySelectorAll(".glide-fullscreen");

  glideDefaults.forEach((glideDefault) => {
    if (glideDefault) {
      setupGlideDefaultInstance(glideDefault, isMobile);
    }
  });


  const carouselContainers = document.querySelectorAll(".carousel-item-container");

  carouselContainers.forEach((carouselContainer) => {
    if (isMobile && carouselContainer) setupMobileSwipe(carouselContainer);
  });

  glideListings.forEach((glideListing, index) => {
    let glideFullscreen = glideFullscreens[index];

    if (glideListing && glideFullscreen) {
      setupGlideListingInstance(glideListing, isMobile);
    }
  });
}
